export const setCookie = (name, value) => {
  localStorage.setItem(name, value);
};

export const getCookie = (name) => {
  return localStorage.getItem(name);
};

export const storeObjectData = async (name = "", value = {}) => {
  try {
    const jsonValue = JSON.stringify(value);
    await localStorage.setItem(name, jsonValue);
    console.log(`localStorage Object Data Store - ${name}`, jsonValue);
  } catch (error) {
    console.log("localStorage Object Data Store", error);
  }
};